import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight, Check } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/api";
import { EMAIL_RE, fieldClass } from "@/lib/validation";

export default function AdminForgotPassword() {
  const [email,     setEmail]     = useState("");
  const [touched,   setTouched]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [done,      setDone]      = useState(false);
  const [loading,   setLoading]   = useState(false);

  const emailErr = !email.trim()
    ? "E-Mail-Adresse ist erforderlich."
    : !EMAIL_RE.test(email.trim())
    ? "Bitte eine gültige E-Mail-Adresse eingeben."
    : null;
  const showErr = (submitted || touched) && !!emailErr;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (emailErr) return;
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase() });
    } catch (_e) { /* swallow — server never enumerates */ }
    finally { setLoading(false); setDone(true); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-porcelain px-5 py-12">
      <div className="w-full max-w-md bg-white border border-sandBeige rounded-3xl p-8 shadow-soft">
        <p className="font-serif text-cocoa text-2xl lowercase">
          womenintech<span className="text-raspberry">.life</span>
        </p>
        <h1 className="font-serif text-3xl text-cocoa mt-4">Passwort vergessen</h1>
        {!done ? (
          <form onSubmit={submit} noValidate className="mt-6 flex flex-col gap-4" data-testid="forgot-form">
            <p className="text-sm text-warmGrey">
              Wir senden dir einen Reset-Link, falls deine E-Mail registriert ist.
            </p>
            <div className="flex flex-col gap-1.5">
              <label htmlFor="forgot-email" className="text-xs font-medium text-cocoa">
                E-Mail <span className="text-raspberry">*</span>
              </label>
              <input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={() => setTouched(true)}
                placeholder="E-Mail"
                className={fieldClass("wit-input", showErr, !!email.trim() && !emailErr)}
                data-testid="forgot-email"
              />
              {showErr && (
                <p className="flex items-center gap-1.5 text-xs text-red-600">
                  <AlertCircle size={12} />{emailErr}
                </p>
              )}
            </div>
            <button
              type="submit"
              disabled={loading}
              className="wit-btn-primary disabled:opacity-60"
              data-testid="forgot-submit"
            >
              {loading ? "Wird gesendet …" : <>Reset-Link anfordern <ArrowRight size={16} /></>}
            </button>
            <Link to="/admin/login" className="text-xs text-warmGrey hover:text-raspberry text-center">
              Zurück zum Login
            </Link>
          </form>
        ) : (
          <div className="mt-6 text-sm text-cocoa flex flex-col gap-4" data-testid="forgot-done">
            <div className="w-12 h-12 rounded-full bg-sageMint flex items-center justify-center">
              <Check size={20} className="text-raspberry" />
            </div>
            <p>Falls deine E-Mail registriert ist, hast du gleich einen Reset-Link im Postfach.</p>
            <Link to="/admin/login" className="wit-btn-secondary">Zurück zum Login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
